module.exports = {versao:  1346 ,
url:"https://sec-api.aplicativogo.com.br"};
